/* global $ */
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'
import './swiper.css'

//Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

function init () {
  $(document).ready(function () {
    // initialize swiper when document ready
    const swiperElem = $('.swiper-container.hero-swiper')
    if (swiperElem.length === 0) {
      return
    }
    let loopVal = false
    if ($(swiperElem).find('.swiper-slide').length > 1) {
      // loop only if swiper has more than 1 slide
      loopVal = true
    }
    
    const swiper = new Swiper(swiperElem[0], {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 2000,
      loop: loopVal,
      watchOverflow: true,
      autoHeight: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true
      },
      pagination: {
        el: $(swiperElem).find('.swiper-pagination')[0],
        clickable: true
      },
      navigation: {
        nextEl: $(swiperElem).find('.swiper-button-next')[0],
        prevEl: $(swiperElem).find('.swiper-button-prev')[0]
      },
      on: { /* fixing loop issue https://github.com/nolimits4web/swiper/issues/7254#issuecomment-2050391040 */
        init: function () {
            // duplicate slides if needed
            if( loopVal ){
                duplicateSlides(swiperElem[0])
            }
        },
        resize: function() {
            // duplicate slides if needed
            if( loopVal ){
                duplicateSlides(swiperElem[0])
            }
        },
        paginationUpdate: function() {
            const countDuplicates = this.slides.filter( el => el.classList.contains('swiper-slide-duplicate') ).length;
            if( countDuplicates ){
                let bulletsDiff = this.pagination.bullets.length - this.slides.length + countDuplicates;
                if( bulletsDiff > 0 ){
                    while( bulletsDiff ){
                        let lastBullet = this.pagination.bullets.pop();
                        lastBullet.remove();
                        bulletsDiff--;
                    }
                }
            }
        }
    }
    })
    swiper.init()
  })
}

function duplicateSlides (swiperElem) {
  if( ! swiperElem.originalSlides ){
      // remember original slides count
      // remember original slides for duplicates
      // remember duplicates
      swiperElem.originalSlides = '';
      swiperElem.duplicateSlides = '';
      swiperElem.originalSlidesCount = swiperElem.swiper.slides.length;
      for( let i = 0; i < swiperElem.originalSlidesCount; i++ ){
          swiperElem.originalSlides += '<div class="swiper-slide" data-swiper-slide-index="' + i + '">' + swiperElem.swiper.slides[ i ].innerHTML + '</div>';
          swiperElem.duplicateSlides += '<div class="swiper-slide swiper-slide-duplicate" data-swiper-slide-index="' + i + '">' + swiperElem.swiper.slides[ i ].innerHTML + '</div>';
      }
  }
  // get current slides width and find the smallest one
  let allSlidesWidth = 0;
  let smallestSlideWidth = Infinity;
  for( let i = 0; i < swiperElem.swiper.slides.length; i++ ){
      const slideWidth = swiperElem.swiper.slides[ i ].offsetWidth;
      allSlidesWidth += slideWidth;
      if( smallestSlideWidth > slideWidth ){
          smallestSlideWidth = slideWidth;
      }
  }
  // if all slides are smaller than swiper area and smallest slide
  const neededDuplicatesCount = Math.ceil( ( swiperElem.swiper.size + smallestSlideWidth ) / allSlidesWidth ) - 1;
  if( neededDuplicatesCount > 0 ){
      const currentDuplicatesCount = swiperElem.swiper.slides.length / swiperElem.originalSlidesCount - 1;
      // reset slides because of possible changed order and mix with duplicates
      // add duplicates
      swiperElem.swiper.slidesEl.innerHTML = swiperElem.originalSlides + swiperElem.duplicateSlides.repeat( currentDuplicatesCount + neededDuplicatesCount );
      swiperElem.swiper.update();
      requestAnimationFrame(function(){
          swiperElem.swiper.loopFix();
          if( swiperElem.swiper.autoplay.paused ){
              swiperElem.swiper.autoplay.start();
          }
      });
  }
}

export default {
  init
}
